import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../utils/api';
import { formatDate } from '../utils/helpers';

// «Торги — беру»: лоты с отметкой «🛒 Берём» на dz.ucfemida.ru. Как «Гражданские дела»: список → карточка
// (Главное / Задачи / Файлы). Данные о лоте — сервер ДЗ через routes/trades.js. 26.10.2026
export const rub = v => v == null ? '—' : Number(v).toLocaleString('ru-RU', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' ₽';
export const dt = s => s ? `${String(s).slice(8, 10)}.${String(s).slice(5, 7)} ${String(s).slice(11, 16)}` : '—';
export const msLeft = s => s ? new Date(s.length <= 19 ? s + '+03:00' : s) - new Date() : null;   // время площадок — московское
export const leftTxt = ms => {
  if (ms == null) return '';
  if (ms <= 0) return 'срок прошёл';
  const h = Math.floor(ms / 36e5), d = Math.floor(h / 24);
  return d >= 1 ? `осталось ${d} дн. ${h % 24} ч` : `осталось ${h} ч ${Math.floor(ms % 36e5 / 6e4)} мин`;
};
// 28.10.2026 владелец: если выбран свой этап позже — красный срок текущего этапа не показывать, это «не тот период»
export const deadline = (x, end) => {
  if (x.plan_from && msLeft(x.plan_from) > 0) return { text: `📅 ваш этап с ${dt(x.plan_from)} мск · через ${leftTxt(msLeft(x.plan_from)).replace('осталось ', '')}`, hot: false };
  const e = x.plan_from && x.plan_to ? x.plan_to : end, ms = msLeft(e);
  return { text: `⏰ до ${dt(e)} мск · ${leftTxt(ms)}`, hot: ms != null && ms < 3 * 864e5 };
};
export const KIND = { dz: 'ДЗ', prop: 'Имущество', comm: 'Коммерция' };

export default function TradesPage() {
  const nav = useNavigate();
  const [list, setList] = useState(null);
  const [err, setErr] = useState('');
  const [bought, setBought] = useState([]);
  const [mg, setMg] = useState(null);   // 04.11.2026: маржа по сделкам
  useEffect(() => {
    api.get('/trades').then(r => { setList(r.data.items || []); setBought(r.data.bought || []); }).catch(e => setErr(e.response?.data?.error || e.message));
    api.get('/trades/margin').then(r => setMg(r.data)).catch(() => {});
  }, []);
  const r0 = v => v == null ? '—' : Math.round(Number(v)).toLocaleString('ru-RU') + ' ₽';
  const byId = Object.fromEntries(((mg && mg.items) || []).map(x => [x.trade_id, x]));
  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">Торги — беру</h1>
        <div style={{ fontSize: 13, color: 'var(--text-muted)' }}>Лоты с отметкой «🛒 Берём» на <a href="https://dz.ucfemida.ru" target="_blank" rel="noopener noreferrer">dz.ucfemida.ru</a> — карточка появляется сама</div>
      </div>
      {mg && mg.total.deals > 0 && (
        <div className="card" style={{ marginBottom: 12 }}>
          <div style={{ fontWeight: 700, marginBottom: 6 }}>💰 Маржа по сделкам</div>
          <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', fontSize: 13.5 }}>
            <span>сделок <b>{mg.total.deals}</b>, закрыто <b>{mg.total.closed}</b></span>
            {mg.total.closed > 0 && <>
              <span>вложено <b>{r0(mg.total.invested)}</b></span>
              <span>прибыль <b style={{ color: mg.total.profit >= 0 ? 'var(--green)' : 'var(--red)' }}>{r0(mg.total.profit)}</b>{mg.total.margin_pct != null ? ` (${mg.total.margin_pct}%)` : ''}</span>
              <span>расходы план/факт <b>{r0(mg.total.plan_cost)}</b> / <b>{r0(mg.total.fact_cost)}</b></span>
              {mg.total.avg_days != null && <span>оборот в среднем <b>{mg.total.avg_days} дн.</b></span>}
            </>}
            <span title="ст. 220 п. 2 пп. 1 НК: при продаже имущества, которым владели меньше 3 лет, вычет до 250 000 ₽ — в целом за год">продажи за год <b>{r0(mg.total.year_sales)}</b>{mg.total.year_sales <= 250000 ? ' — в пределах вычета 250 000 ₽, НДФЛ 0' : ' — больше 250 000 ₽: налог с (продажа − покупка)'}</span>
          </div>
        </div>
      )}
      {bought.length > 0 && (
        <div style={{ marginBottom: 12 }}>
          <div style={{ fontWeight: 700, margin: '4px 0 8px' }}>🧾 Куплено — в учёте</div>
          {bought.map(b => { const m = byId[b.trade_id] || {};
            return (
              <div key={b.trade_id} className="card" onClick={() => nav(`/trades/${b.trade_id}?tab=money`)} style={{ marginBottom: 8, cursor: 'pointer', overflowWrap: 'anywhere' }}>
                <div style={{ fontWeight: 700 }}>{b.sold ? '🏁' : '🛒'} {b.number} · лот {b.lot_order} <span style={{ fontWeight: 400, fontSize: 13, color: 'var(--text-muted)' }}>{(b.title || '').slice(0, 120)}</span></div>
                <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', fontSize: 13, marginTop: 4 }}>
                  <span>вложено <b>{r0(m.invested)}</b></span>
                  {b.sold ? <span>маржа <b style={{ color: m.profit >= 0 ? 'var(--green)' : 'var(--red)' }}>{r0(m.profit)}</b>{m.margin_pct != null ? ` (${m.margin_pct}%)` : ''}{m.days != null ? ` · ${m.days} дн.` : ''}</span>
                    : <span style={{ color: 'var(--text-muted)' }}>ещё не продано{m.buy_date ? ` · куплено ${String(m.buy_date).slice(0, 10).split('-').reverse().join('.')}` : ''}</span>}
                </div>
              </div>); })}
        </div>
      )}
      {err && <div className="card" style={{ color: 'var(--red)' }}>{err}</div>}
      {list == null && !err && <div className="card">загрузка…</div>}
      {list && !list.length && <div className="card" style={{ color: 'var(--text-muted)' }}>Нет лотов с отметкой «🛒 Берём».</div>}
      {list && list.map(x => {
        const e = x.etp || {}, end = e.period_end || x.date_finish, dl = deadline(x, end), hot = dl.hot;
        const done = (x.steps || []).filter(s => s.done).length;
        return (
          <div key={x.trade_id} className="card" onClick={() => nav(`/trades/${x.trade_id}`)}
            style={{ marginBottom: 12, cursor: 'pointer', overflowWrap: 'anywhere', borderColor: hot ? 'var(--red)' : undefined }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', gap: 10, flexWrap: 'wrap' }}>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontWeight: 700, fontSize: 15 }}>
                  <span style={{ fontSize: 11, border: '1px solid var(--border)', borderRadius: 999, padding: '1px 8px', marginRight: 6, color: 'var(--text-muted)' }}>{KIND[x.kind]}</span>
                  {x.number} · лот {x.lot_order}
                </div>
                <div style={{ fontSize: 13, color: 'var(--text-muted)' }}>{(x.description || '').slice(0, 160)}</div>
              </div>
              <span style={{ fontWeight: 700, padding: '4px 10px', borderRadius: 999, background: hot ? 'var(--red-bg)' : 'var(--bg-hover)', color: hot ? 'var(--red)' : undefined, height: 'fit-content' }}>
                {dl.text}
              </span>
            </div>
            <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', marginTop: 8, fontSize: 13 }}>
              {x.plan_from && <span style={{ color: 'var(--accent)' }}>📅 беру с <b>{dt(x.plan_from)}</b>{x.plan_price ? <> за <b>{rub(x.plan_price)}</b></> : ''}</span>}
              <span>цена этапа <b>{rub(e.price)}</b></span>
              <span>задаток <b>{rub(e.deposit)}</b></span>
              <span>шаги <b>{done} из {(x.steps || []).length}</b></span>
              <span>задачи <b>{x.tasks_open}</b>{x.tasks_next ? ` (ближ. ${formatDate(x.tasks_next)})` : ''}</span>
              <span>файлы <b>{x.files_n}</b></span>
              {/* 28.10.2026 владелец: счётчик заявок и ссылки прямо из списка */}
              <span style={{ color: e.bids ? 'var(--red)' : undefined }}>заявок <b>{e.bids == null ? 'нет данных' : e.bids}</b>{e.bids ? ' 🔴' : ''}</span>
            </div>
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 8 }} onClick={ev => ev.stopPropagation()}>
              <a className="btn btn-secondary btn-sm" href={`https://dz.ucfemida.ru/${x.kind === 'dz' ? '' : x.kind}#${x.bidding_guid}:${x.lot_order}`} target="_blank" rel="noopener noreferrer">Дашборд ↗</a>
              {x.lot_url && <a className="btn btn-secondary btn-sm" href={x.lot_url} target="_blank" rel="noopener noreferrer">{x.lot_direct ? 'Лот на площадке ↗' : 'Площадка ↗'}</a>}
              <a className="btn btn-secondary btn-sm" href={`https://fedresurs.ru/biddings/${x.bidding_guid}`} target="_blank" rel="noopener noreferrer">Федресурс ↗</a>
            </div>
          </div>
        );
      })}
    </div>
  );
}
